import { Component, OnInit } from '@angular/core';
import { PopoverController } from '@ionic/angular';

@Component({
  selector: 'app-meeting-states',
  templateUrl: './meeting-states.component.html',
  styleUrls: ['./meeting-states.component.scss'],
})
export class MeetingStatesComponent implements OnInit {
  public statesButtons = [
    {
      txt: 'ASISTIO',
      id: 3,
    },
    {
      txt: 'INCUMPLIO',
      id: 4,
    },
  ];

  constructor(private popoverController: PopoverController) {}

  ngOnInit() {}

  async changeState(state) {
    await this.popoverController.dismiss(state);
  }
}
